import _ from 'lodash';
import async from 'async';
import moment from 'moment';
import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import CheckIcon from '@material-ui/icons/CheckCircle';

import FMPTextField from '../../components/ui/FMPTextField';
import BulkDeliveryContainer from '../../containers/logistics/BulkDelivery';
import BulkDeliveryBatchContainer from '../../containers/logistics/BulkDeliveryBatch';
import ActivatingDeliveryDialog from '../../components/Dialogs/ConfirmingDialog';
import { getHtml } from './helpers';

const styles = (theme) => {
	return {
		note: {
			backgroundColor: '#D8F0FF',
			padding: 20,
			fontSize: 16,
			lineHeight: 1.4,
			marginBottom: 10,
			marginTop: 10,
			border: '1px solid #BADEFB',
		},
		lastChange: {
			//border: '2px solid #bbb',
			//backgroundColor: '#f1f1f1',
			backgroundColor: '#D8F0FF',
			border: '1px solid #BADEFB',
			borderRadius: 4,
			padding: 20,
			fontSize: 16,
			lineHeight: 1.4,
			marginBottom: 10,
			marginTop: 20,
		},
		sectionHeader: {
			margin: '30px 0px 10px 0px',
			textAlign: 'left',
			textTransform: 'uppercase',
			fontSize: 14,
			color: '#777',
			fontWeight: 900,
			letterSpacing: 2,
		},
		paper: {
			width: '100%',
			overflowX: 'auto',
			textAlign: 'left',
			boxSizing: 'border-box',
			padding: 20,
			[theme.breakpoints.up('md')]: {
				padding: '20px 30px 30px 30px',
			},
		},
		submitButton: {
			fontSize: 18,
			borderRadius: '100px',
			padding: '20px 30px',
			textTransform: 'uppercase',
		},
		orderDetails: {
			paddingTop: 40,
			fontSize: 24,
			fontWeight: 300,
			borderBottom: '1px solid #ddd',
		},
		infoSection: {
			paddingTop: 20,
			lineHeight: 1.4,
		},
		check: {
			color: '#4CAF50',
			width: 40,
			height: 40,
			verticalAlign: 'middle',
			paddingRight: 5,
		},
		confirmedTitle: {
			fontSize: 24,
			fontWeight: 500,
			padding: 20,
		},
		confirmedMessage: {
			padding: 20,
			lineHeight: 1.4,
			fontSize: 16,
		},
	};
};
const formFields = {
	supplierLoadingNumbersSubmittedBy: '',
	bulkDeliveries: [],
	loadingNumber: '',
};

class SubmitSupplierLoadingNumbers extends Component {
	constructor(props) {
		super(props);
		const bulkDeliveryBatchId = _.get(this.props, ['match', 'params', 'bulkDeliveryBatchId']);
		const bulkDeliveryId = _.get(this.props, ['match', 'params', 'bulkDeliveryId']);
		const securityHash = _.get(this.props, ['match', 'params', 'securityHash']);

		this.state = {
			bulkDeliveryBatchId: bulkDeliveryBatchId ? parseInt(bulkDeliveryBatchId, 10) : undefined,
			bulkDeliveryId: bulkDeliveryId ? parseInt(bulkDeliveryId, 10) : undefined,
			securityHash,
			errors: [],
			infoSection: undefined,
			formFieldError: {},
			isActiveDialogOpen: false,
			activatingStatus: 'pending',
		};
		this.state = _.merge(this.state, formFields);
	}

	componentDidMount() {
		getHtml({
			props: this.props,
			state: this.state,
			showCarrier: true,
			callback: (newState) => {
				this.setState(newState);
			},
		});
	}

	//- THis means we got teh bulkDeliveryBatch
	componentDidUpdate(prevProps) {
		const newState = this.getDidUpdateState({ prevProps, props: this.props });
		this.setState(newState);
	}

	getDidUpdateState = ({ prevProps, props }) => {
		const { bulkDeliveryBatch, bulkDelivery, bulkDeliveryMap } = props;

		if (bulkDeliveryBatch && !prevProps.bulkDeliveryBatch) {
			const { bulkDeliveryIds } = bulkDeliveryBatch;
			const errors = [];
			const bulkDeliveries = [];

			bulkDeliveryIds.forEach((bulkDeliveryId) => {
				const bulkDelivery = bulkDeliveryMap[bulkDeliveryId];
				if (!bulkDelivery) {
					return errors.push(`Could not find delivery : ${bulkDeliveryId}`);
				}
				bulkDeliveries.push(bulkDelivery);
			});

			if (!_.isEmpty(errors)) {
				return { errors };
			}

			if (_.isEmpty(bulkDeliveries)) {
				return { errors: ['Could not find any deliveries on this order.'] };
			}
			return { bulkDeliveries };
		}

		if (bulkDelivery && !prevProps.bulkDelivery) {
			const { loadingNumber } = bulkDelivery;
			return { loadingNumber };
		}
	};

	handleConfirm = () => {
		const {
			showErrors,
			submitSupplierLoadingNumbersForBatch,
			submitSupplierLoadingNumbers,
		} = this.props;

		const {
			bulkDeliveryId,
			bulkDeliveryBatchId,
			securityHash,

			bulkDeliveries,
			supplierLoadingNumbersSubmittedBy,
			loadingNumber,
		} = this.state;

		const requiredFields = [
			{ display: 'Confirm By', fieldName: 'supplierLoadingNumbersSubmittedBy' },
		];
		if (bulkDeliveryId) {
			requiredFields.push({ display: 'Loading number', fieldName: 'loadingNumber' });
		}
		//- Required fields
		const formFieldError = {};
		const errors = [];
		requiredFields.forEach((s) => {
			if (!this.state[s.fieldName]) {
				formFieldError[s.fieldName] = `${s.display} is required`;
				errors.push(`${s.display} is required`);
			}
		});

		let params = {};
		if (bulkDeliveryBatchId) {
			const bulkDeliveryLoadingNumbers = [];
			bulkDeliveries.forEach((bulkDelivery, i) => {
				if (!bulkDelivery.loadingNumber) {
					_.set(formFieldError, ['bulkDeliveries', i, 'loadingNumber'], 'Loading number required');
				}
				bulkDeliveryLoadingNumbers.push({
					bulkDeliveryId: bulkDelivery.bulkDeliveryId,
					loadingNumber: bulkDelivery.loadingNumber,
				});
			});

			if (formFieldError.bulkDeliveries) {
				errors.push('All loading numbers required');
			}

			params = {
				bulkDeliveryBatchId,
				securityHash,
				supplierLoadingNumbersSubmittedBy,
				bulkDeliveryLoadingNumbers,
			};
		} else {
			params = {
				bulkDeliveryId,
				securityHash,
				supplierLoadingNumbersSubmittedBy,
				loadingNumber,
			};
		}

		if (_.keys(formFieldError).length) {
			this.setState({ formFieldError });
			showErrors(errors);
			return;
		}

		this.setState({
			isActiveDialogOpen: true,
			activatingStatus: 'activating',
		});

		setTimeout(() => {
			async.waterfall(
				[
					(callback) => {
						if (bulkDeliveryBatchId) {
							submitSupplierLoadingNumbersForBatch({
								params,
								callback,
							});
						} else {
							submitSupplierLoadingNumbers({
								params,
								callback,
							});
						}
					},
				],
				(err, r) => {
					const newState = { activatingStatus: 'done' };
					if (err) {
						newState.errors = [err];
					}

					const emailHtml = _.get(r, ['emailHtml']);
					if (emailHtml) {
						newState.emailHtml = emailHtml;
					} else {
						newState.errors = ['Missing info section'];
					}

					return this.setState(newState);
				}
			);
		}, 1000);
	};

	closeActivatingDialog = () => {
		this.setState({ isActiveDialogOpen: false });
	};

	onChange = (event, fieldName, index, attr) => {
		if (!_.isNumber(index)) {
			this.setState({ [fieldName]: event.target.value });
		} else {
			const inputs = this.state[fieldName].slice();
			if (attr) {
				inputs[index][attr] = event.target.value;
			} else {
				inputs[index] = event.target.value;
			}
			this.setState({ [fieldName]: inputs });
		}
	};

	render() {
		const { classes, bulkDeliveryBatch, supplierMap, bulkDeliveryMap } = this.props;

		let bulkDelivery = this.props.bulkDelivery;

		const { errors, emailHtml, isActiveDialogOpen, activatingStatus } = this.state;

		if (!_.isEmpty(errors)) {
			return (
				<div>
					<div>Encountered an error when retrieving the order</div>
					{errors.map((error, i) => {
						return <div key={i}>{error}</div>;
					})}
					;
				</div>
			);
		}

		if (!bulkDeliveryBatch && !bulkDelivery) {
			return <div>Fetching delivery information...</div>;
		}
		if (!emailHtml) {
			return <div>Fetching delivery details...</div>;
		}

		if (bulkDeliveryBatch) {
			const { bulkDeliveryIds } = bulkDeliveryBatch;
			const bulkDeliveryId = _.first(bulkDeliveryIds);
			bulkDelivery = bulkDeliveryMap[bulkDeliveryId];
			if (!bulkDelivery) {
				return <div>BulkDelivery not found:{bulkDeliveryId} not found in the system</div>;
			}
		}

		const { pickupSupplierId } = bulkDelivery;
		const supplier = supplierMap[pickupSupplierId];
		if (!supplier) {
			return <div>SupplierID:{pickupSupplierId} not found in the system</div>;
		}

		let title = 'Loading Number Request';
		let buttonText = 'Submit Loading Numbers';

		const { supplierLoadingNumbersSubmittedBy } = bulkDelivery;
		return (
			<Grid container spacing={3}>
				<Grid item xs={12}>
					<Grid container spacing={3}>
						<Grid item xs={12}>
							<Typography variant="h5" align="left" gutterBottom>
								{title}
							</Typography>
						</Grid>
					</Grid>
					<Paper className={classes.paper}>
						<div className={classes.note}>
							This loading number request is intended for <strong>{supplier.name}</strong>. If you
							have received this order in error please contact
							<a href="mailto:dispatch@pearsonfuels.com">dispatch@pearsonfuels.com</a> or call
							833-385-3835.
							<br />
							<br />
							If you are <strong>{supplier.name}</strong>, please fill out the following information
							and click {buttonText}.
						</div>

						{!supplierLoadingNumbersSubmittedBy &&
							this.renderForm({
								buttonText,
							})}
						{supplierLoadingNumbersSubmittedBy &&
							this.renderConfirmed({
								bulkDelivery,
							})}

						<div className={classes.infoSection}>
							<div dangerouslySetInnerHTML={{ __html: emailHtml }} />
						</div>
					</Paper>

					<ActivatingDeliveryDialog
						open={isActiveDialogOpen}
						onClose={this.closeActivatingDialog}
						status={activatingStatus}
					/>
				</Grid>
			</Grid>
		);
	}

	renderForm({ buttonText }) {
		const { classes } = this.props;
		const { bulkDeliveryBatchId, isActiveDialogOpen } = this.state;

		return (
			<div>
				<FMPTextField
					name={'supplierLoadingNumbersSubmittedBy'}
					label={`Name of individual submitting this`}
					controller={this}
					helpText={'required'}
				/>

				{!!bulkDeliveryBatchId && this.renderDeliveries()}
				{!bulkDeliveryBatchId && this.renderDelivery()}

				<div style={{ paddingTop: 40 }}>
					<Button
						disabled={isActiveDialogOpen}
						variant="contained"
						color="primary"
						className={classes.submitButton}
						onClick={this.handleConfirm}
					>
						{buttonText}
					</Button>
				</div>
			</div>
		);
	}

	renderConfirmed({ bulkDelivery }) {
		const { classes } = this.props;
		const {
			supplierLoadingNumbersSubmittedBy,
			supplierLoadingNumbersSubmittedDateTime,
		} = bulkDelivery;

		const dateConfirmedFormatted = moment(supplierLoadingNumbersSubmittedDateTime).format(
			'dddd, MMMM Do, YYYY [at] h:mm a'
		);

		return (
			<div>
				<div className={classes.confirmedTitle}>
					<CheckIcon className={classes.check} /> This loading number request has been successfully
					submitted
				</div>
				<div className={classes.confirmedMessage}>
					Loading numbers submitted by <strong>{supplierLoadingNumbersSubmittedBy}</strong> on{' '}
					{dateConfirmedFormatted}.
				</div>
			</div>
		);
	}

	renderDeliveries() {
		const { classes } = this.props;
		const { bulkDeliveries } = this.state;
		return (
			<div>
				<div className={classes.sectionHeader}>DELIVERIES</div>

				{bulkDeliveries.map((bulkDelivery, i) => {
					const dateFormatted = moment(bulkDelivery.deliveryDate).format('dddd M/D');

					const backgroundColor = !(i % 2) ? '#fff' : '#f2f2f2';
					return (
						<Grid key={i} container spacing={3} className={classes.inputGroup}>
							<Grid
								item
								xs={6}
								md={2}
								style={{
									backgroundColor,
									marginTop: 10,
									fontWeight: 900,
									textAlign: 'right',
									padding: '30px 10px',
								}}
							>
								{dateFormatted}
							</Grid>

							<Grid
								item
								xs={6}
								md={4}
								style={{ backgroundColor, marginTop: 10, padding: '5px 10px', paddingBottom: 10 }}
							>
								<FMPTextField
									label={'Loading Number'}
									name={'bulkDeliveries'}
									attr={'loadingNumber'}
									index={i}
									controller={this}
									md={12}
									helpText={'required'}
								/>
							</Grid>
						</Grid>
					);
				})}
			</div>
		);
	}

	renderDelivery() {
		const { classes } = this.props;
		const { deliveryDate } = this.state;
		const dateFormatted = moment(deliveryDate).format('dddd M/D');

		return (
			<div>
				<div className={classes.sectionHeader}>DELIVERY</div>
				<Grid container spacing={3} className={classes.inputGroup}>
					<Grid
						item
						xs={6}
						md={2}
						style={{ marginTop: 10, fontWeight: 900, textAlign: 'right', padding: '30px 10px' }}
					>
						{dateFormatted}
					</Grid>

					<Grid
						item
						xs={6}
						md={4}
						style={{ marginTop: 10, padding: '5px 10px', paddingBottom: 10 }}
					>
						<FMPTextField
							label={'Loading Number'}
							name={'loadingNumber'}
							controller={this}
							md={12}
							helpText={'required'}
						/>
					</Grid>
				</Grid>
			</div>
		);
	}
}

SubmitSupplierLoadingNumbers.propTypes = {
	classes: PropTypes.object.isRequired,
	showErrors: PropTypes.func,

	//- Batch
	submitSupplierLoadingNumbersForBatch: PropTypes.func,
	publicGetBulkDeliveryBatch: PropTypes.func,
	bulkDeliveryBatch: PropTypes.object,

	//- Single
	submitSupplierLoadingNumbers: PropTypes.func,
	publicGetBulkDelivery: PropTypes.func,
	bulkDelivery: PropTypes.object,

	supplierMap: PropTypes.object,
	bulkDeliveryMap: PropTypes.object,
	//terminalMap : PropTypes.object,
	//supplierMap : PropTypes.object,
	//resourceMap : PropTypes.object,
	//stationMap : PropTypes.object,
};

export default _.flow([withStyles(styles), BulkDeliveryContainer, BulkDeliveryBatchContainer])(
	SubmitSupplierLoadingNumbers
);
